<template>
	<div>
		<i class="icon" :class="iconCabecalho"></i>
		<h3>{{ titulo.toUpperCase() }}</h3>
		<h4 @click="_exibeSub(submenuModulo)" class="titulo_h4">
			{{ subTituloCabecalho.toUpperCase() }}
			<i class="fa fa-angle-down" aria-hidden="true"></i>
		</h4>
	</div>
</template>

<script>
export default {
	props: {
		titulo: {
			type: String,
			required: true
		},
		subTitulo: {
			type: String,
			required: false
		},
		iconCabecalho: {
			type: String,
			required: false,
			default: 'icon-novo_cadastro'
		},
		submenuModulo: {
			type: String,
			default: 'ad'
		}
	},

	computed: {
		subTituloCabecalho() {
			return this.subTitulo || `${this._traducao('menu', 'menuAdministracao')} ${this._traducao('menu', 'menuGeral')}`
		}
	}
}
</script>

<style scoped>
.titulo_h4 {
	cursor: pointer;
}
</style>
